class CustomProductBundle extends HTMLElement {
  constructor() {
    super();
    this.threepack = [];
    this.fourpack = [];
    this.sixpack = [];
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var this2 = this;

      // Make sure error messages can reappear when Add to Cart is clicked
      $(document).on("click", ".product-form__submit", function() {
        // Reset visibility of error containers to ensure new errors can appear
        $(".error-msg-bundle").removeClass("hidden");
        $(".error-message").removeClass("hidden");
        $("[role='alert']").removeClass("hidden");
        $(".product-form__error-message-wrapper").removeClass("hidden").css("display", "");
      });

      $('input[name="product-tab-size"]').change(function () {
        $(".error-msg-bundle").addClass("hidden").hide();

        $(".custom-bundle-products-container")
          .find("img")
          .attr(
            "src",
            "https://cdn.shopify.com/s/files/1/0282/7839/0819/files/icon_plus_bg_61dac0b7-87db-4251-bbc9-7cc874e643fa.png?v=1716033324?v=1713546942"
          );
        $(".custom-bundle-products-container").find(".remove-product").hide();
        $(".custom-bundle-products-container")
          .find(".custom-bundle-products-title")
          .html("");
        $(".product-bundle-product-checkbox").prop("checked", false);

        $(".orginal-product-form")
          .find('fieldset[data-optionname="Size"]')
          .find(
            'input[value="' +
              $('input[name="product-tab-size"]:checked').val() +
              '"]'
          )
          .click();
        $(".product-bundle-product-checkbox").removeAttr("disabled");
        $(".custom-product-minus").css("pointer-events", "auto");
        $(".custom-product-plus").css("pointer-events", "auto");
        $(".custom-product-input").val(0);
        $(".custom-product-quantity").hide();

        if ($('input[name="product-tab-size"]:checked').val() == "3-PACK") {
          $('.custom-bundle-products-container[data-index="4"]').hide();
          $('.custom-bundle-products-container[data-index="5"]').hide();
          $('.custom-bundle-products-container[data-index="6"]').hide();
          $(".custom-product-bundle-products-mobile .select-count").html(
            `Select your products (0/3)`
          );
          for (let index = 0; index < this2.threepack.length; index++) {
            var job = this2.threepack[index];

            $(
              '.product-bundle-product-checkbox[value="' + job["id"] + '"]'
            ).prop("checked", true);
            $('.product-bundle-product-checkbox[value="' + job["id"] + '"]')
              .parent()
              .find(".custom-product-input")
              .val(Number(job["qty"]));
            $('.product-bundle-product-checkbox[value="' + job["id"] + '"]')
              .parent()
              .find(".custom-product-quantity")
              .show();
          }
          if (window.matchMedia("(min-width: 768px)").matches) {
            reloaddesktopview();
          } else {
            reloadmobileview();
          }
        }
        if ($('input[name="product-tab-size"]:checked').val() == "4-PACK") {
          $('.custom-bundle-products-container[data-index="4"]').show();
          $('.custom-bundle-products-container[data-index="5"]').hide();
          $('.custom-bundle-products-container[data-index="6"]').hide();
          $(".custom-product-bundle-products-mobile .select-count").html(
            `Select your products (0/4)`
          );
          for (let index = 0; index < this2.fourpack.length; index++) {
            var job = this2.fourpack[index];
            $(
              '.product-bundle-product-checkbox[value="' + job["id"] + '"]'
            ).prop("checked", true);
            $('.product-bundle-product-checkbox[value="' + job["id"] + '"]')
              .parent()
              .find(".custom-product-input")
              .val(Number(job["qty"]));
            $('.product-bundle-product-checkbox[value="' + job["id"] + '"]')
              .parent()
              .find(".custom-product-quantity")
              .show();
          }
          if (window.matchMedia("(min-width: 768px)").matches) {
            reloaddesktopview();
          } else {
            reloadmobileview();
          }
        }
        if ($('input[name="product-tab-size"]:checked').val() == "6-PACK") {
          $('.custom-bundle-products-container[data-index="4"]').show();
          $('.custom-bundle-products-container[data-index="5"]').show();
          $('.custom-bundle-products-container[data-index="6"]').show();
          $(".custom-product-bundle-products-mobile .select-count").html(
            `Select your products (0/6)`
          );
          for (let index = 0; index < this2.sixpack.length; index++) {
            var job = this2.sixpack[index];
            $(
              '.product-bundle-product-checkbox[value="' + job["id"] + '"]'
            ).prop("checked", true);
            $('.product-bundle-product-checkbox[value="' + job["id"] + '"]')
              .parent()
              .find(".custom-product-input")
              .val(Number(job["qty"]));
            $('.product-bundle-product-checkbox[value="' + job["id"] + '"]')
              .parent()
              .find(".custom-product-quantity")
              .show();
          }
          if (window.matchMedia("(min-width: 768px)").matches) {
            reloaddesktopview();
          } else {
            reloadmobileview();
          }
        }
      });

      $(".desktop-view .product-bundle-product-checkbox").change(function () {
        if ($(this).prop("checked") == true) {
          $(this).parent().find(".custom-product-quantity").show();
          $(this).parent().find(".custom-product-input").val(1);
        } else {
          $(this).parent().find(".custom-product-quantity").hide();
          $(this).parent().find(".custom-product-input").val(0);
        }
        reloaddesktopview();
      });
      $(".mobile-view .product-bundle-product-checkbox").change(function () {
        if ($(this).prop("checked") == true) {
          $(this).parent().find(".custom-product-quantity").show();
          $(this).parent().find(".custom-product-input").val(1);
        } else {
          $(this).parent().find(".custom-product-quantity").hide();
          $(this).parent().find(".custom-product-input").val(0);
        }
        reloadmobileview();
      });

      $(".custom-product-plus").click(function () {
        const nextQuantity = Number($(this).prev().val()) + 1;

        const selectedPack = $(".orginal-product-form").find('fieldset[data-optionname="Packaging"]').find("input:checked").val();
        const selectedPackagingVariant = selectedPack.includes('Jars') ? 'availableJars' : 'availableBags';
        const maxQuantity = $(this).closest('.custom-products-wrapper').find('.product-bundle-product-checkbox').data(selectedPackagingVariant);

        if (nextQuantity <= maxQuantity) {
          $(this).prev().val(nextQuantity);
          if (window.matchMedia("(min-width: 768px)").matches) {
            reloaddesktopview();
          } else {
            reloadmobileview();
          }
        } else {
          toast.show('The selected quantity exceeds our available stock.', 5000, 'alert');
        }
      });
      $(".custom-product-minus").click(function () {
        if ($(this).next().val() > 0) {
          if ($(this).next().val() == 1) {
            $(this)
              .parents(".custom-products-wrapper")
              .find(".product-bundle-product-checkbox")
              .prop("checked", false);
            $(this)
              .parents(".custom-products-wrapper")
              .find(".custom-product-quantity")
              .hide();
          }
          $(this)
            .next()
            .val(Number($(this).next().val()) - 1);
        }
        if (window.matchMedia("(min-width: 768px)").matches) {
          reloaddesktopview();
        } else {
          reloadmobileview();
        }
      });

      $(".remove-product").click(function () {
        // Hide all error messages in a way that can be reset
        $(".error-msg-bundle").addClass("hidden").hide();
        $(".error-message").addClass("hidden").hide();
        $("[role='alert']").addClass("hidden").hide();
        $(".product-form__error-message-wrapper").addClass("hidden").css("display", "none");
        
        var cpcount = $(
          '.desktop-view .product-bundle-product-checkbox[data-pname="' +
            $(this)
              .parents(".custom-bundle-products-container")
              .attr("data-pname") +
            '"]'
        )
          .parent()
          .find(".custom-product-input")
          .val();
        if (cpcount > 1) {
          $(
            '.desktop-view .product-bundle-product-checkbox[data-pname="' +
              $(this)
                .parents(".custom-bundle-products-container")
                .attr("data-pname") +
              '"]'
          )
            .parent()
            .find(".custom-product-input")
            .val(cpcount - 1);
        } else {
          $(
            '.desktop-view .product-bundle-product-checkbox[data-pname="' +
              $(this)
                .parents(".custom-bundle-products-container")
                .attr("data-pname") +
              '"]'
          ).prop("checked", false);
        }
        
        // Re-enable Add To Cart button if it was disabled
        $(".shopify-payment-button__button").prop("disabled", false).attr("aria-disabled", false);
        $(".product-form__submit").prop("disabled", false).attr("aria-disabled", false);
        
        reloaddesktopview();
      });

      function reloaddesktopview() {
        // Hide bundle-specific error messages in a way that can be reset
        $(".error-msg-bundle").addClass("hidden").hide();
        
        // Re-enable Add To Cart button if it was disabled
        $(".shopify-payment-button__button").prop("disabled", false).attr("aria-disabled", false);
        $(".product-form__submit").prop("disabled", false).attr("aria-disabled", false);

        $(".custom-bundle-products-container")
          .find("img")
          .attr(
            "src",
            "https://cdn.shopify.com/s/files/1/0282/7839/0819/files/icon_plus_bg_61dac0b7-87db-4251-bbc9-7cc874e643fa.png?v=1716033324"
          );
        $(".custom-bundle-products-container")
          .find(".custom-bundle-products-title")
          .html("");
        $(".custom-bundle-products-container").find(".remove-product").hide();

        var totalcount = 0;
        var aradded = [];

        $(".desktop-view .product-bundle-product-checkbox:checked").each(
          function (index) {
            // Check if checkbox is within a custom-products-wrapper
            const productWrapper = $(this).closest('.custom-products-wrapper');
            if (productWrapper.length) {
              var job = {};
              // Use data-varid attribute instead of checkbox value
              job["id"] = $(this).attr("data-varid");
              // Fallback to checkbox value if data-varid is not available
              if (!job["id"]) {
                job["id"] = $(this).val();
              }
              job["qty"] = Number(productWrapper.find(".custom-product-input").val() || 1);
              console.log("Adding desktop product:", job["id"], "qty:", job["qty"]);
              aradded.push(job);
              
              totalcount += job["qty"];

              for (
                let index = 1;
                index <= job["qty"];
                index++
              ) {
                var ind = totalcount + 1 - index;
                $('.custom-bundle-products-container[data-index="' + ind + '"]')
                  .find("img")
                  .attr("src", productWrapper.find("img").attr("src"));
                $('.custom-bundle-products-container[data-index="' + ind + '"]')
                  .find(".custom-bundle-products-title")
                  .html($(this).attr("data-pname"));
                $('.custom-bundle-products-container[data-index="' + ind + '"]')
                  .find(".remove-product")
                  .show();
                $(
                  '.custom-bundle-products-container[data-index="' + ind + '"]'
                ).attr("data-pname", $(this).attr("data-pname"));
              }
            }
          }
        );
        if (
          $(
            '.desktop-view .custom-products-wrapper[data-ptype="seasonal"] .product-bundle-product-checkbox:checked'
          ).length > 0
        ) {
          $(".orginal-product-form").hide();
          $('.orginal-product-form[data-packsize="seasonal"]').show();
        } else {
          $(".orginal-product-form").hide();
          $('.orginal-product-form[data-packsize="all"]').show();
        }

        if ($('input[name="product-tab-size"]:checked').val() == "3-PACK") {
          this2.threepack = [];
          this2.threepack = aradded;
          localStorage.setItem("threepack", JSON.stringify(this2.threepack));
          if (totalcount >= 3) {
            $(
              ".desktop-view .product-bundle-product-checkbox:not(:checked)"
            ).attr("disabled", true);

            $(".custom-product-plus").css("pointer-events", "none");
          } else {
            $(".desktop-view .product-bundle-product-checkbox").removeAttr(
              "disabled"
            );
            $(".custom-product-minus").css("pointer-events", "auto");
            $(".custom-product-plus").css("pointer-events", "auto");
          }
        }
        if ($('input[name="product-tab-size"]:checked').val() == "4-PACK") {
          this2.fourpack = [];
          this2.fourpack = aradded;
          localStorage.setItem("fourpack", JSON.stringify(this2.fourpack));
          if (totalcount >= 4) {
            $(
              ".desktop-view .product-bundle-product-checkbox:not(:checked)"
            ).attr("disabled", true);

            $(".custom-product-plus").css("pointer-events", "none");
          } else {
            $(".desktop-view .product-bundle-product-checkbox").removeAttr(
              "disabled"
            );
            $(".custom-product-minus").css("pointer-events", "auto");
            $(".custom-product-plus").css("pointer-events", "auto");
          }
        }
        if ($('input[name="product-tab-size"]:checked').val() == "6-PACK") {
          this2.sixpack = [];
          this2.sixpack = aradded;
          localStorage.setItem("sixpack", JSON.stringify(this2.sixpack));
          if (totalcount >= 6) {
            $(
              ".desktop-view .product-bundle-product-checkbox:not(:checked)"
            ).attr("disabled", true);

            $(".custom-product-plus").css("pointer-events", "none");
          } else {
            $(".desktop-view .product-bundle-product-checkbox").removeAttr(
              "disabled"
            );
            $(".custom-product-minus").css("pointer-events", "auto");
            $(".custom-product-plus").css("pointer-events", "auto");
          }
        }

        localStorage.setItem(
          "packsize",
          $('input[name="product-tab-size"]:checked').val()
        );
      }

      function reloadmobileview() {
        // Hide bundle-specific error messages in a way that can be reset
        $(".error-msg-bundle").addClass("hidden").hide();
        
        // Re-enable Add To Cart button if it was disabled
        $(".shopify-payment-button__button").prop("disabled", false).attr("aria-disabled", false);
        $(".product-form__submit").prop("disabled", false).attr("aria-disabled", false);

        var totalcount = 0;
        var aradded = [];
        $(".mobile-view .product-bundle-product-checkbox:checked").each(
          function (index) {
            // Check if checkbox is within a custom-products-wrapper
            const productWrapper = $(this).closest('.custom-products-wrapper');
            if (productWrapper.length) {
              var job = {};
              // Use data-varid attribute instead of checkbox value
              job["id"] = $(this).attr("data-varid");
              // Fallback to checkbox value if data-varid is not available
              if (!job["id"]) {
                job["id"] = $(this).val();
              }
              job["qty"] = Number(productWrapper.find(".custom-product-input").val() || 1);
              console.log("Adding mobile product:", job["id"], "qty:", job["qty"]);
              aradded.push(job);
              
              totalcount += job["qty"];
            }
          }
        );

        if ($('input[name="product-tab-size"]:checked').val() == "3-PACK") {
          this2.threepack = [];
          this2.threepack = aradded;
          localStorage.setItem("threepack", JSON.stringify(this2.threepack));
          $(".custom-product-bundle-products-mobile .select-count").html(
            `Select your products (${totalcount}/3)`
          );
          if (totalcount >= 3) {
            $(".product-bundle-product-checkbox:not(:checked)").attr(
              "disabled",
              true
            );

            $(".custom-product-plus").css("pointer-events", "none");
          } else {
            $(".product-bundle-product-checkbox").removeAttr("disabled");
            $(".custom-product-minus").css("pointer-events", "auto");
            $(".custom-product-plus").css("pointer-events", "auto");
          }
        }
        if ($('input[name="product-tab-size"]:checked').val() == "4-PACK") {
          this2.fourpack = [];
          this2.fourpack = aradded;
          localStorage.setItem("fourpack", JSON.stringify(this2.fourpack));
          $(".custom-product-bundle-products-mobile .select-count").html(
            `Select your products (${totalcount}/4)`
          );
          if (totalcount >= 4) {
            $(".product-bundle-product-checkbox:not(:checked)").attr(
              "disabled",
              true
            );

            $(".custom-product-plus").css("pointer-events", "none");
          } else {
            $(".product-bundle-product-checkbox").removeAttr("disabled");
            $(".custom-product-minus").css("pointer-events", "auto");
            $(".custom-product-plus").css("pointer-events", "auto");
          }
        }
        if ($('input[name="product-tab-size"]:checked').val() == "6-PACK") {
          this2.sixpack = [];
          this2.sixpack = aradded;
          localStorage.setItem("sixpack", JSON.stringify(this2.sixpack));
          $(".custom-product-bundle-products-mobile .select-count").html(
            `Select your products (${totalcount}/6)`
          );
          if (totalcount >= 6) {
            $(".product-bundle-product-checkbox:not(:checked)").attr(
              "disabled",
              true
            );
            $(".custom-product-plus").css("pointer-events", "none");
          } else {
            $(".product-bundle-product-checkbox").removeAttr("disabled");
            $(".custom-product-minus").css("pointer-events", "auto");
            $(".custom-product-plus").css("pointer-events", "auto");
          }
        }
        if (
          $(
            '.mobile-view .custom-products-wrapper[data-ptype="seasonal"] .product-bundle-product-checkbox:checked'
          ).length > 0
        ) {
          $(".orginal-product-form").hide();
          $('.orginal-product-form[data-packsize="seasonal"]').show();
        } else {
          $(".orginal-product-form").hide();
          $('.orginal-product-form[data-packsize="all"]').show();
        }

        localStorage.setItem(
          "packsize",
          $('input[name="product-tab-size"]:checked').val()
        );
      }

      $(".custom-product-bundle-products-mobile").click(function () {
        $(".mobile-view .custom-products-container-main").toggleClass(
          "is-active"
        );
        $(".mobile-view .mobile-arrows").toggleClass("is-active");
      });
      $('fieldset[data-optionname="Packaging"] input').change(function () {
        $(".orginal-product-form")
          .find('fieldset[data-optionname="Packaging"]')
          .find('input[value="' + $(this).val() + '"]')
          .click();
        if ($(this).val() == "Bags") {
          $(".custom-products-image img").each(function () {
            $(this).attr("src", $(this).parent().attr("data-bagimage"));
          });
        }
        if ($(this).val() == "Jars") {
          $(".custom-products-image img").each(function () {
            $(this).attr("src", $(this).parent().attr("data-jarimage"));
          });
        }
        if (window.matchMedia("(min-width: 768px)").matches) {
          reloaddesktopview();
        } else {
          reloadmobileview();
        }
      });

      window.addEventListener("pageshow", () => {
        console.log(document.referrer)
        $(document).ready(function () {
          if (localStorage.hasOwnProperty("threepack")) {
            this2.threepack = JSON.parse(localStorage.getItem("threepack"));
          }
          if (localStorage.hasOwnProperty("fourpack")) {
            this2.fourpack = JSON.parse(localStorage.getItem("fourpack"));
          }
          if (localStorage.hasOwnProperty("sixpack")) {
            this2.sixpack = JSON.parse(localStorage.getItem("sixpack"));
          }
          $(".orginal-product-form")
            .find('fieldset[data-optionname="Packaging"]')
            .find('input[value="Bags"]')
            .click();
          $(
            'fieldset[data-optionname="Packaging"] input[value="Bags"]'
          ).click();
          if (localStorage.hasOwnProperty("packsize")) {
            var packsize = localStorage.getItem("packsize");
            console.log("Detected packsize from localStorage:", packsize);
            
            // Click on pack size first
            $('input[name="product-tab-size"][value="' + packsize + '"]').click();

            // Function to reliably apply saved product selections
            function applyStoredSelections(storedItems) {
              console.log("Applying stored selections:", storedItems);
              
              // First clear all selections
              $(".product-bundle-product-checkbox").prop("checked", false);
              $(".custom-product-quantity").hide();
              $(".custom-product-input").val(0);
              
              // Apply each stored selection
              storedItems.forEach(function(item) {
                if (item && item.id) {
                  console.log("Processing item:", item.id, "quantity:", item.qty);
                  
                  // Try to find checkboxes by data-varid first
                  let desktopCheckbox = $(".desktop-view .custom-products-container-main .custom-products-wrapper .product-bundle-product-checkbox[data-varid='" + item.id + "']");
                  let mobileCheckbox = $(".mobile-view .custom-products-container-main .custom-products-wrapper .product-bundle-product-checkbox[data-varid='" + item.id + "']");
                  
                  // If not found by data-varid, try by value
                  if (desktopCheckbox.length === 0) {
                    desktopCheckbox = $(".desktop-view .custom-products-container-main .custom-products-wrapper .product-bundle-product-checkbox[value='" + item.id + "']");
                  }
                  
                  if (mobileCheckbox.length === 0) {
                    mobileCheckbox = $(".mobile-view .custom-products-container-main .custom-products-wrapper .product-bundle-product-checkbox[value='" + item.id + "']");
                  }
                  
                  console.log("Found checkboxes - Desktop:", desktopCheckbox.length, "Mobile:", mobileCheckbox.length);
                  
                  // Apply to desktop view
                  if (desktopCheckbox.length) {
                    desktopCheckbox.prop("checked", true);
                    const quantityInput = desktopCheckbox.closest(".custom-products-wrapper").find(".custom-product-input");
                    quantityInput.val(Number(item.qty || 1));
                    desktopCheckbox.closest(".custom-products-wrapper").find(".custom-product-quantity").show();
                  }
                  
                  // Apply to mobile view
                  if (mobileCheckbox.length) {
                    mobileCheckbox.prop("checked", true);
                    const quantityInput = mobileCheckbox.closest(".custom-products-wrapper").find(".custom-product-input");
                    quantityInput.val(Number(item.qty || 1));
                    mobileCheckbox.closest(".custom-products-wrapper").find(".custom-product-quantity").show();
                  }
                }
              });
              
              // Refresh the view
              if (window.matchMedia("(min-width: 768px)").matches) {
                reloaddesktopview();
              } else {
                reloadmobileview();
              }
            }

            // Setup UI based on pack size
            if (packsize === "3-PACK") {
              $('.custom-bundle-products-container[data-index="4"]').hide();
              $('.custom-bundle-products-container[data-index="5"]').hide();
              $('.custom-bundle-products-container[data-index="6"]').hide();
              applyStoredSelections(this2.threepack || []);
            } 
            else if (packsize === "4-PACK") {
              $('.custom-bundle-products-container[data-index="4"]').show();
              $('.custom-bundle-products-container[data-index="5"]').hide();
              $('.custom-bundle-products-container[data-index="6"]').hide();
              applyStoredSelections(this2.fourpack || []);
            } 
            else if (packsize === "6-PACK") {
              $('.custom-bundle-products-container[data-index="4"]').show();
              $('.custom-bundle-products-container[data-index="5"]').show();
              $('.custom-bundle-products-container[data-index="6"]').show();
              applyStoredSelections(this2.sixpack || []);
            }
          }
        });

        var historyTraversal = event.persisted || 
                         ( typeof window.performance != "undefined" && 
                              window.performance.navigation.type === 2 );
          if ( historyTraversal && window.location.href.indexOf('custom-bundle') != -1) { 
            window.location.reload();
          }
      });
       
      // Function to refresh the pack from local storage
      function refreshPackFromStorage(packName) {
        if (localStorage.hasOwnProperty(packName)) {
          const storedItems = JSON.parse(localStorage.getItem(packName));
          console.log("Refreshing from storage:", packName, storedItems);
          
          // Clear all selections
          $(".product-bundle-product-checkbox").prop("checked", false);
          $(".custom-product-quantity").hide();
          $(".custom-product-input").val(0);
          
          // Apply each stored selection
          storedItems.forEach(function(item) {
            if (item && item.id) {
              // Try to find checkboxes by data-varid first
              let desktopCheckbox = $(".desktop-view .product-bundle-product-checkbox[data-varid='" + item.id + "']");
              let mobileCheckbox = $(".mobile-view .product-bundle-product-checkbox[data-varid='" + item.id + "']");
              
              // If not found by data-varid, try by value
              if (desktopCheckbox.length === 0) {
                desktopCheckbox = $(".desktop-view .product-bundle-product-checkbox[value='" + item.id + "']");
              }
              
              if (mobileCheckbox.length === 0) {
                mobileCheckbox = $(".mobile-view .product-bundle-product-checkbox[value='" + item.id + "']");
              }
              
              // Apply to desktop view
              if (desktopCheckbox.length) {
                desktopCheckbox.prop("checked", true);
                desktopCheckbox.closest(".custom-products-wrapper").find(".custom-product-input").val(Number(item.qty || 1));
                desktopCheckbox.closest(".custom-products-wrapper").find(".custom-product-quantity").show();
              }
              
              // Apply to mobile view
              if (mobileCheckbox.length) {
                mobileCheckbox.prop("checked", true);
                mobileCheckbox.closest(".custom-products-wrapper").find(".custom-product-input").val(Number(item.qty || 1));
                mobileCheckbox.closest(".custom-products-wrapper").find(".custom-product-quantity").show();
              }
            }
          });
          
          // Refresh the view
          if (window.matchMedia("(min-width: 768px)").matches) {
            reloaddesktopview();
          } else {
            reloadmobileview();
          }
        }
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-product-bundle", CustomProductBundle);

// Helper function to ensure UI state matches storage data
function ensureSelectionMatches(storage, packSize) {
  if (localStorage.hasOwnProperty(storage)) {
    const items = JSON.parse(localStorage.getItem(storage));
    $(".product-bundle-product-checkbox").prop("checked", false);
    $(".custom-product-quantity").hide();
    $(".custom-product-input").val(0);
    
    items.forEach(item => {
      if (item && item.id) {
        const checkbox = $(`.product-bundle-product-checkbox[value="${item.id}"]`);
        checkbox.prop("checked", true).trigger("change");
        checkbox.parent().find(".custom-product-input").val(Number(item.qty || 1));
        checkbox.parent().find(".custom-product-quantity").show();
      }
    });
    
    if (window.matchMedia("(min-width: 768px)").matches) {
      reloaddesktopview();
    } else {
      reloadmobileview();
    }
  }
}